import { render, staticRenderFns } from "./NewPositionCard.vue?vue&type=template&id=ece0750a&"
import script from "./NewPositionCard.vue?vue&type=script&lang=js&"
export * from "./NewPositionCard.vue?vue&type=script&lang=js&"
import style0 from "./NewPositionCard.vue?vue&type=style&index=0&id=ece0750a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports